const VITESSE_VERIFICATION_METHOD_SOURCES = {
  claim_number: {
    desc: 'Claim Number',
  },
  policy_number: {
    desc: 'Policy Number',
  },
  incident_configured_field: {
    desc: 'Incident Configured Field',
  },
} as const;

export default VITESSE_VERIFICATION_METHOD_SOURCES;
